import InfoIcon from "@/icons/InfoIcon";
import useReadingSkillsContext from "@/view/utils/useReadingSkillsContext";
import { iconCss, rootCss, textCss } from "./ReadingSkillsAssessMessage.style";

const ReadingSkillsAssessMessage = () => {
  const { readingSkillState } = useReadingSkillsContext();

  const filteredSelectedReadingSkills = Object.fromEntries(
    Object.entries(readingSkillState).filter(
      ([, { isReadingSkillSelected }]) => isReadingSkillSelected,
    ),
  );

  const numberOfQuestionsSelected = Object.values(
    filteredSelectedReadingSkills,
  ).reduce((numberOfQuestionsSelected, questions) => {
    const selectedQuestions = Object.values(questions).filter(
      ({ isQuizQuestionSelected }) => !!isQuizQuestionSelected,
    );
    return numberOfQuestionsSelected + selectedQuestions.length;
  }, 0);

  const readingSkillTitles = Object.keys(filteredSelectedReadingSkills).join(
    " and ",
  );

  const messageText = numberOfQuestionsSelected
    ? `Based on your reading skills focus, assigning this quiz will assess 
  ${readingSkillTitles} with ${numberOfQuestionsSelected} question${
    numberOfQuestionsSelected === 1 ? "" : "s"
  }.`
    : "Please select at least one question to assign this quiz.";

  return (
    <div css={rootCss}>
      <InfoIcon css={iconCss} />
      <p css={textCss}>{messageText}</p>
    </div>
  );
};

export default ReadingSkillsAssessMessage;
